import { Skeleton } from "@/components/ui/skeleton";
import {
  DashboardContentZone,
  DashboardControlRow,
} from "@/components/patterns/content-zone";
import { DataTableSurface } from "@/components/patterns/table-chrome";
import { cn } from "@/lib/utils";

interface TableCardSkeletonProps {
  rows: number;
  columns: number;
  showToolbar?: boolean;
  showFooter?: boolean;
  className?: string;
}

export function TableCardSkeleton({
  rows,
  columns,
  showToolbar = false,
  showFooter = false,
  className,
}: TableCardSkeletonProps) {
  return (
    <DashboardContentZone className={className}>
      {showToolbar && (
        <DashboardControlRow>
          <Skeleton className="h-10 w-64 rounded-lg" />
          <div className="flex items-center gap-3">
            <Skeleton className="h-9 w-24 rounded-lg" />
            <Skeleton className="h-9 w-32 rounded-lg" />
          </div>
        </DashboardControlRow>
      )}
      <DataTableSurface className="space-y-3 bg-card p-4">
        <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
          {Array.from({ length: columns }).map((_, index) => (
            <Skeleton key={index} className="h-4 w-full" />
          ))}
        </div>
        <div className="space-y-3">
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              className="grid items-center gap-4 py-4"
              style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
            >
              {Array.from({ length: columns }).map((_, columnIndex) => (
                <Skeleton
                  key={`${rowIndex}-${columnIndex}`}
                  className={cn(
                    "h-10 w-full rounded-xl",
                    columnIndex === 0
                      ? "max-w-full"
                      : columnIndex === columns - 1
                        ? "max-w-[80%]"
                        : "max-w-[90%]",
                  )}
                />
              ))}
            </div>
          ))}
        </div>
      </DataTableSurface>
      {showFooter && (
        <div className="flex items-center justify-between gap-3">
          <Skeleton className="h-4 w-36" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-9 w-24 rounded-lg" />
            <Skeleton className="h-9 w-20 rounded-lg" />
          </div>
        </div>
      )}
    </DashboardContentZone>
  );
}
